/* tslint:disable */
/* eslint-disable */
/**
 * EcoCerram API
 * EcoCerram API generated from BE
 *
 * The version of the OpenAPI document: 0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BecomePartnerForm
 */
export interface BecomePartnerForm {
    /**
     * 
     * @type {string}
     * @memberof BecomePartnerForm
     */
    companyName?: string;
    /**
     * 
     * @type {string}
     * @memberof BecomePartnerForm
     */
    companyType?: string;
    /**
     * 
     * @type {string}
     * @memberof BecomePartnerForm
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof BecomePartnerForm
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof BecomePartnerForm
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof BecomePartnerForm
     */
    ico?: string;
    /**
     * 
     * @type {string}
     * @memberof BecomePartnerForm
     */
    dic?: string;
    /**
     * 
     * @type {string}
     * @memberof BecomePartnerForm
     */
    icDph?: string;
    /**
     * 
     * @type {string}
     * @memberof BecomePartnerForm
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof BecomePartnerForm
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof BecomePartnerForm
     */
    zipCode?: string;
    /**
     * 
     * @type {string}
     * @memberof BecomePartnerForm
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof BecomePartnerForm
     */
    recaptchaToken?: string;
    /**
     * 
     * @type {string}
     * @memberof BecomePartnerForm
     */
    locale?: BecomePartnerFormLocaleEnum;
}


/**
 * @export
 */
export const BecomePartnerFormLocaleEnum = {
    Sk: 'SK',
    En: 'EN',
    Pl: 'PL',
    Hu: 'HU',
    De: 'DE'
} as const;
export type BecomePartnerFormLocaleEnum = typeof BecomePartnerFormLocaleEnum[keyof typeof BecomePartnerFormLocaleEnum];


/**
 * Check if a given object implements the BecomePartnerForm interface.
 */
export function instanceOfBecomePartnerForm(value: object): value is BecomePartnerForm {
    return true;
}

export function BecomePartnerFormFromJSON(json: any): BecomePartnerForm {
    return BecomePartnerFormFromJSONTyped(json, false);
}

export function BecomePartnerFormFromJSONTyped(json: any, ignoreDiscriminator: boolean): BecomePartnerForm {
    if (json == null) {
        return json;
    }
    return {
        
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
        'companyType': json['companyType'] == null ? undefined : json['companyType'],
        'description': json['description'] == null ? undefined : json['description'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'ico': json['ico'] == null ? undefined : json['ico'],
        'dic': json['dic'] == null ? undefined : json['dic'],
        'icDph': json['icDph'] == null ? undefined : json['icDph'],
        'street': json['street'] == null ? undefined : json['street'],
        'city': json['city'] == null ? undefined : json['city'],
        'zipCode': json['zipCode'] == null ? undefined : json['zipCode'],
        'country': json['country'] == null ? undefined : json['country'],
        'recaptchaToken': json['recaptchaToken'] == null ? undefined : json['recaptchaToken'],
        'locale': json['locale'] == null ? undefined : json['locale'],
    };
}

export function BecomePartnerFormToJSON(json: any): BecomePartnerForm {
    return BecomePartnerFormToJSONTyped(json, false);
}

export function BecomePartnerFormToJSONTyped(value?: BecomePartnerForm | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyName': value['companyName'],
        'companyType': value['companyType'],
        'description': value['description'],
        'email': value['email'],
        'phone': value['phone'],
        'ico': value['ico'],
        'dic': value['dic'],
        'icDph': value['icDph'],
        'street': value['street'],
        'city': value['city'],
        'zipCode': value['zipCode'],
        'country': value['country'],
        'recaptchaToken': value['recaptchaToken'],
        'locale': value['locale'],
    };
}

